export const pattern = {
  onlyNumbers: /^\d*\.?\d*$/,
  onlyAlphaNumeric: /^[a-zA-Z0-9]*$/,
  numberWithDecimel: /^(?:\d{1,5}|\d{1,5}\.\d{1,2})$/,
  AlphaNumericForAddress: /^[a-zA-Z0-9\-',_.#& ]*$/,
  decimalRegex: /^(?!\d{6,})(?!.*\.\d{3,})\d{1,5}(\.\d{0,2})?$/
};

export const EmailIDPattern = /^[_a-zA-Z0-9!#$%&'*+-/=?^_`{|}~;]+(\.[_a-zA-Z0-9!#$%&'*+-/=?^_`{|}~;]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z])/g;
export const passwordWithoutSpace = /[^\s]+$/g;